// // 测试
//const VUE_APP_WS_URL = 'ws://goldmany.live801.com/websocket';
//const VUE_APP_BASEURL = 'http://goldmany.live801.com';

// 正式
// 测试
//const VUE_APP_WS_URL = 'ws://127.0.0.1:8083/websocket';//测试
//const VUE_APP_BASEURL = 'http://127.0.0.1:8083';//测试
const VUE_APP_WS_URL = 'wss://web.pcmexpo.com/websocket';//测试
const VUE_APP_BASEURL = 'https://web.pcmexpo.com';//测试


export { VUE_APP_WS_URL, VUE_APP_BASEURL };